import React from 'react'
import { Colors } from 'baseStyles/enums/colors'
import Box from './Box'

interface IDividerProps {
    marginTop?: number;
    marginBottom?: number;
    backgroundColor?: string;
}

const Divider: React.FC<IDividerProps> = ({marginTop = 0, marginBottom = 0, backgroundColor = Colors.LIGHT_GREY_1}) => {
    return (
        <Box
            width={`100%`}
            height={1}
            backgroundColor={backgroundColor}
            margin={`${marginTop}px 0 ${marginBottom}px 0`}
        />
    )
}

export default Divider